module.exports = __webpack_public_path__ + "img/three-iphones-mobile@3x.6e54b028.png";